import {
  submitFormdataForSelection,
  uploadContributionFile,
} from '@/service/vbef'
import { mapState } from 'vuex'
import filter from 'js/filter'

const MOBILE_REGEX = /^1[3-9]\d{9}$/

export default {
  data() {
    return {
      filter,
      buttonLoading: false,
      logoFile: null,
      logoUploadPath: '',
      logoDisplayName: '',
      attachmentFile: null,
      attachmentUploadPath: '',
      attachmentDisplayName: '',
      currentForm: {
        fullName: '',
        shortName: '',
        name: '',
        title: '',
        mobile: '',
        email: '',
        compDesc: '',
        content: '',
        milestone: '',
        logoPath: '',
        filePath: '',
      },
      ruleValidate: {
        fullName: [
          {
            required: true,
            message: filter.dealLanguage(
              '请填写公司全称',
              'Please fill in the company full name',
            ),
            trigger: 'blur',
          },
        ],
        shortName: [
          {
            required: true,
            message: filter.dealLanguage(
              '请填写公司简称',
              'Please fill in the company short name',
            ),
            trigger: 'blur',
          },
        ],
        name: [
          {
            required: true,
            message: filter.dealLanguage(
              '请填写联系人姓名',
              'Please fill in the contact name',
            ),
            trigger: 'blur',
          },
        ],
        title: [
          {
            required: true,
            message: filter.dealLanguage(
              '请填写联系人职务',
              'Please fill in the contact title',
            ),
            trigger: 'blur',
          },
        ],
        mobile: [
          {
            required: true,
            message: filter.dealLanguage(
              '请输入联系人手机',
              'Please enter the contact mobile number',
            ),
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: this.validateMobile,
          },
        ],
        email: [
          {
            required: true,
            message: filter.dealLanguage(
              '请填写邮箱',
              'Please fill in your email',
            ),
            trigger: 'blur',
          },
          {
            type: 'email',
            message: filter.dealLanguage(
              '邮箱格式不正确',
              'The email format is incorrect',
            ),
            trigger: 'blur',
          },
        ],
        compDesc: [
          {
            required: true,
            message: filter.dealLanguage(
              '请填写公司简介',
              'Please fill in the company introduction',
            ),
            trigger: 'blur',
          },
        ],
        content: [
          {
            required: true,
            message: filter.dealLanguage(
              '请填写创新说明',
              'Please fill in the innovation statement',
            ),
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: this.validateInnovationContent,
          },
        ],
        milestone: [
          {
            required: true,
            message: filter.dealLanguage(
              '请填写最新里程碑',
              'Please fill in the latest milestone',
            ),
            trigger: 'blur',
          },
        ],
        logoPath: [
          {
            required: true,
            message: filter.dealLanguage(
              '请上传公司 Logo',
              'Please upload the company logo',
            ),
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      uuserId: (state) => state.uuserId,
      language: (state) => state.language,
      isMobile: (state) => state.isMobile,
    }),
    innovationWordCount() {
      return this.countWords(this.currentForm.content)
    },
  },
  created() {
    this.fillContactInfo()
  },
  methods: {
    countWords(text) {
      const matches = String(text || '').match(
        /[A-Za-z0-9]+(?:['’-][A-Za-z0-9]+)?|[\u4e00-\u9fa5]/g,
      )
      return matches ? matches.length : 0
    },
    fillContactInfo() {
      if (!this.user) return
      this.currentForm.name = this.user.name || this.currentForm.name
      this.currentForm.title = this.user.title || this.currentForm.title
      this.currentForm.email = this.user.email || this.currentForm.email
      this.currentForm.mobile = this.user.mobile || this.currentForm.mobile
    },
    validateMobile(rule, value, callback) {
      if (!value) {
        callback()
        return
      }
      if (!MOBILE_REGEX.test(String(value))) {
        callback(
          new Error(
            filter.dealLanguage(
              '手机号格式不正确',
              'The phone number format is incorrect',
            ),
          ),
        )
        return
      }
      callback()
    },
    validateInnovationContent(rule, value, callback) {
      if (this.countWords(value) > 500) {
        callback(
          new Error(
            filter.dealLanguage(
              '创新说明最多 500 字',
              'Innovation statement can contain up to 500 words',
            ),
          ),
        )
        return
      }
      callback()
    },
    triggerLogoSelect() {
      if (this.$refs.logoInput) this.$refs.logoInput.click()
    },
    triggerAttachmentSelect() {
      if (this.$refs.attachmentInput) this.$refs.attachmentInput.click()
    },
    handleLogoChange(event) {
      const file = event.target.files && event.target.files[0]
      if (!file) return
      const allowReg = /\.(png|jpg|jpeg|webp)$/i
      if (!allowReg.test(file.name)) {
        this.showError(
          filter.dealLanguage(
            'Logo 仅支持 PNG、JPG、JPEG、WEBP 格式',
            'Logo only supports PNG, JPG, JPEG and WEBP formats',
          ),
        )
        event.target.value = ''
        return
      }
      this.logoFile = file
      this.logoUploadPath = ''
      this.logoDisplayName = file.name
      this.currentForm.logoPath = file.name
    },
    handleAttachmentChange(event) {
      const file = event.target.files && event.target.files[0]
      if (!file) return
      const allowReg = /\.(png|jpg|jpeg|pdf|doc|docx|ppt|pptx|zip)$/i
      if (!allowReg.test(file.name)) {
        this.showError(
          filter.dealLanguage(
            '附件仅支持 PNG、JPG、JPEG、PDF、DOC、DOCX、PPT、PPTX、ZIP 格式',
            'Attachment only supports PNG, JPG, JPEG, PDF, DOC, DOCX, PPT, PPTX and ZIP formats',
          ),
        )
        event.target.value = ''
        return
      }
      this.attachmentFile = file
      this.attachmentUploadPath = ''
      this.attachmentDisplayName = file.name
      this.currentForm.filePath = file.name
    },
    handleRemoveLogo() {
      this.logoFile = null
      this.logoUploadPath = ''
      this.logoDisplayName = ''
      this.currentForm.logoPath = ''
      if (this.$refs.logoInput) this.$refs.logoInput.value = ''
    },
    handleRemoveAttachment() {
      this.attachmentFile = null
      this.attachmentUploadPath = ''
      this.attachmentDisplayName = ''
      this.currentForm.filePath = ''
      if (this.$refs.attachmentInput) this.$refs.attachmentInput.value = ''
    },
    async ensureLogoUploaded() {
      if (!this.logoFile) return this.logoUploadPath
      const res = await uploadContributionFile(this.logoFile)
      if (res.code !== 0) {
        throw new Error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
      this.logoUploadPath = res.data || ''
      this.logoDisplayName = this.logoFile.name
      this.logoFile = null
      this.currentForm.logoPath = this.logoUploadPath
      if (this.$refs.logoInput) this.$refs.logoInput.value = ''
      return this.logoUploadPath
    },
    async ensureAttachmentUploaded() {
      if (!this.attachmentFile) return this.attachmentUploadPath
      const res = await uploadContributionFile(this.attachmentFile)
      if (res.code !== 0) {
        throw new Error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
      this.attachmentUploadPath = res.data || ''
      this.attachmentDisplayName = this.attachmentFile.name
      this.attachmentFile = null
      this.currentForm.filePath = this.attachmentUploadPath
      if (this.$refs.attachmentInput) this.$refs.attachmentInput.value = ''
      return this.attachmentUploadPath
    },
    buildSubmitParams() {
      return {
        fullName: this.currentForm.fullName,
        shortName: this.currentForm.shortName,
        name: this.currentForm.name,
        title: this.currentForm.title,
        mobile: this.currentForm.mobile,
        email: this.currentForm.email,
        compDesc: this.currentForm.compDesc,
        content: this.currentForm.content,
        milestone: this.currentForm.milestone,
        logoPath: this.logoUploadPath,
        filePath: this.attachmentUploadPath,
        type: this.language == 'zh' ? 1 : 2,
        xuserId: (this.user && this.user.id) || this.uuserId || 0,
      }
    },
    async handleSubmit() {
      if (this.buttonLoading) return
      this.$refs['current-form'].validate(async (valid) => {
        if (!valid) {
          this.showError(
            filter.dealLanguage(
              '存在未完善选项，请检查后再提交',
              'There are incomplete items. Please check before submitting',
            ),
          )
          return
        }
        this.buttonLoading = true
        try {
          await this.ensureLogoUploaded()
          await this.ensureAttachmentUploaded()
          const res = await submitFormdataForSelection(this.buildSubmitParams())
          if (res.code === 0) {
            this.handleSubmitSuccess()
            this.resetForm()
          } else {
            this.showError(filter.dealLanguage(res.msg, res.enMsg || res.msg))
          }
        } catch (error) {
          this.showError(error.message || error)
        } finally {
          this.buttonLoading = false
        }
      })
    },
    resetForm() {
      this.logoFile = null
      this.logoUploadPath = ''
      this.logoDisplayName = ''
      this.attachmentFile = null
      this.attachmentUploadPath = ''
      this.attachmentDisplayName = ''
      this.currentForm = {
        fullName: '',
        shortName: '',
        name: '',
        title: '',
        mobile: '',
        email: '',
        compDesc: '',
        content: '',
        milestone: '',
        logoPath: '',
        filePath: '',
      }
      this.$nextTick(() => {
        if (this.$refs['current-form']) this.$refs['current-form'].resetFields()
        this.fillContactInfo()
      })
    },
    handleSubmitSuccess() {
      const title = filter.dealLanguage('提交成功！', 'Submitted successfully!')
      const content = filter.dealLanguage(
        '您填写的创新之星申报信息已提交成功',
        'Your Innovation Awards application has been submitted successfully',
      )
      if (this.$Modal && this.$Modal.success) {
        this.$Modal.success({
          title,
          content,
          okText: filter.dealLanguage('返回首页', 'Return Home'),
          onOk: () => {
            this.$router.push({ name: 'index' })
          },
        })
        return
      }
      if (this.$dialog && this.$dialog.alert) {
        this.$dialog
          .alert({
            title,
            message: content,
            confirmButtonText: filter.dealLanguage('返回首页', 'Return Home'),
            theme: 'round-button',
          })
          .then(() => {
            this.$router.push({ name: 'index' })
          })
        return
      }
    },
    showError(message) {
      if (this.$Message && this.$Message.error) {
        this.$Message.error(message)
        return
      }
      if (this.$notify) {
        this.$notify(message)
      }
    },
  },
}
